var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"disabled":_vm.working},on:{"click":function($event){return _vm.doClick()}}},[_vm._v(" Force Complete "),(_vm.working)?_c('b-spinner',{attrs:{"small":"","label":"completing"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }